<template>
    <div>
      <FilterTable 
        :resource_name="resource_name"
        :title="title"
        :field_definitions="field_definitions"
        :filters="filters"
        :action_buttons="action_buttons"
        :row_actions="row_actions"
        :translate_to_display_data="translate_to_display_data"
        :route_root="route_root"
        :handle_row_action="handle_row_action"
        :full_text_search="true"
        :handle_action_button_click="handle_action_button_click"
        :update_flag="filter_table_update_flag"
      />
      <LoadingBlock
          :active="loading">
      </LoadingBlock>
    </div>
</template>

<script>
// @ is an alias to /src
//import Main from '@/components/backstage/Main.vue'
import FilterTable from '@/components/backstage/FilterTable/FilterTable.vue'
import LoadingBlock from '@/components/backstage/LoadingBlock/LoadingBlock.vue'
import api from '@/api/index'
import breadcrumbMixin from '@/mixins/breadcrumbMixin'

export default {
    mixins: [breadcrumbMixin],
    components: {
      FilterTable,
      LoadingBlock
    },
    created () {
      this.permission_check({
        resource_info: { name: this.page_name.PAGE_ACCOUNT_MANAGEMENT },
        access: { name: this.permission.VIEW },
        reject: { action: this.permission.REJECT_REDIRECT, path: '/dashboard' }
      })
    },
    data() {
      return {
        resource_name: 'account',
        title: '帳號管理',
        route_root: 'system-management/account-management',
        field_definitions: [
          {
            display: {
              name: '編號',
              type: 'string',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'id',
              data_type: 'string',
            } 
          },
          {
            display: {
              name: '姓名',
              type: 'string',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'username',
              data_type: 'string',
            } 
          },
          {
            display: {
              name: '單位名稱',
              type: 'string',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'org_name',
              data_type: 'string',
            }
          },
          {
            display: {
              name: '權限角色',
              type: 'string',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'roles',
              data_type: 'role-array',
            }
          },
        ],
        filters: {
          '權限角色': {
            paramName: 'fk_role_id',
            value: null,
            options: {
              list: [],
              type: 'db',
              endpoint: '/role/list',
              params: [],
              method: 'post',
              label: 'name',
              value: 'id'
            },
          },
        },
        action_buttons: {
          add: {
            label: '新增使用者',
            action: 'add'
          },
        },
        row_actions: {

          get: {
            label: '檢視',
            action: 'get'
          },
          edit: {
            label: '編輯',
            action: 'edit',
            enable: (row) => this.check_row(this.permission.EDIT, row)
          },
          suspend: {
            label: '凍結',
            action: 'suspend',
            enable: (row) => (row['status'] === '開通') && this.check_row(this.permission.SUSPEND, row)
          },
          resume: {
            label: '復原',
            action: 'resume',
            enable: (row) => (row['status'] !== '開通') && this.check_row(this.permission.RESUME, row)
          },
          delete: {
            label: '刪除',
            action: 'delete',
            enable: (row) => this.check_row(this.permission.DELETE, row)
          },
        },
        loading: false,
        filter_table_update_flag: 0
      }
    },
    methods: {
      check_row(access, row) {
        if (!this.account_info || !this.account_info['roles']) {
          return false
        }

        return this.permission_check({
          resource_info: { 
            name: this.permission.RESOURCE_ACCOUNT_MANAGEMENT,
            owner_identifier: 'id',
            context: { 
              id: row.id,
              roles: row.roles
            }
          },
          access: { name: access },
        })
      },
      translate_to_display_data(data) {
        console.log('translate_to_display_data')

        let types = {}
        this.field_definitions.forEach(
          function (field) {
            types[field['source']['key']] = field['source']['data_type']
          })

        let translated_data = data
        
        for (let key in data) {
          if (types[key] === 'datetime' && data[key]) {
            translated_data[key] = data[key].date.slice(0,-7)
          }
        }
        
        return translated_data
      },
      handle_row_action (action, index, row) {
        console.log('AccountManagementPage: action:' + action + ', index: ' + index + ', row: ', row)

          switch(action){
            case 'get': 
                this.backstage_router_push({ path: `/${this.route_root}/view/${row.id}` })
                break
            case 'edit': 
                this.backstage_router_push({ path: `/${this.route_root}/edit/${row.id}` })
                break
            case 'suspend': 
                this.handle_activate_account(false, row.id)
                break
            case 'resume': 
                this.handle_activate_account(true, row.id)
                break
            case 'delete': 
                this.handle_delete_account(row.id)
                break
            default:
                break
          }
      },
      handle_action_button_click (action) {
        console.log('AccountManagementPage: action button clicked: ', action)

        switch(action){
          case 'add': 
            this.backstage_router_push({ path: `/${this.route_root}/add` })
            break
          case 'export': 
              break
          default:
              break
        }
      },
      async handle_activate_account (activate, id) {
        console.log('activate user: activate=', activate, ', id=', id)
        this.loading = true
        let res = await api.activate_user(activate, id)
        if (res.code === 200) {
          this.notify_message(this.ERROR.LEVEL.SUCCESS, (activate? '復原': '凍結')+'帳號成功', '')
        }else {
          this.notify_message(this.ERROR.LEVEL.ERROR, (activate? '復原': '凍結')+'帳號失敗', res.message)
        }
        this.loading = false
        this.filter_table_update_flag += 1
      },
      async handle_delete_account (id) {
        console.log('delete user: id=', id)
        this.loading = true
        let res = await api.delete_user(id)
        if (res.code === 200) {
          this.notify_message(this.ERROR.LEVEL.SUCCESS, '刪除帳號成功', '')
        }else {
          this.notify_message(this.ERROR.LEVEL.ERROR, '刪除帳號失敗', res.message)
        }
        this.loading = false
        this.filter_table_update_flag += 1
      }
    }
  };
</script>

<style>
</style>
